import React from 'react';
import { supabase } from '../../utils/supabase';


export function ImpersonationBanner() {
  const [isImpersonating, setIsImpersonating] = React.useState(false);
  const [impersonatedUser, setImpersonatedUser] = React.useState<{ email: string } | null>(null);

  React.useEffect(() => {
    const impersonating = localStorage.getItem('isImpersonating') === 'true';
    const userStr = localStorage.getItem('impersonatedUser');

    if (impersonating && userStr) {
      setIsImpersonating(true);
      setImpersonatedUser(JSON.parse(userStr));
    }
  }, []);

  const handleExitImpersonation = async () => {
    // Clear impersonation flags
    localStorage.removeItem('isImpersonating');
    localStorage.removeItem('impersonatedUser');

    // Sign out and redirect to login
    await supabase.auth.signOut();
    window.location.href = '/login';
  };

  if (!isImpersonating || !impersonatedUser) {
    return null;
  }

  return (
    <div style={{
      background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      color: 'white',
      padding: '12px 20px',
      textAlign: 'center',
      fontWeight: 600,
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
      position: 'sticky',
      top: 0,
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '20px'
    }}>
      <span>
        🔍 Impersonating user: {impersonatedUser.email}
      </span>
      <button
        onClick={handleExitImpersonation}
        style={{
          background: 'white',
          color: '#f5576c',
          border: 'none',
          padding: '6px 16px',
          borderRadius: '5px',
          fontWeight: 600,
          cursor: 'pointer',
          fontSize: '14px'
        }}
      >
        Exit Impersonation
      </button>
    </div>
  );
}
